import fetch from '@/utils/fetch'

/**
 * 七牛token
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getToken() {
  return fetch({
    url: '/api_user/service/aw/mul/ow/common/get_token',
    method: 'post',
    data: {}
  })
}

/**
 * 更新session心跳接口
 *
 * @export
 * @param {any} data
 * @returns
 */
export function heartbeat() {
  return fetch({
    url: '/api_user/service/aw/mul/ow/common/heart',
    method: 'post',
    data: {}
  })
}

/**
 * 七牛图片格式转换
 *
 * @export
 * @param {any} data
 * @returns
 */
export function imageConvert(url, format) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/common/image/convert',
    method: 'post',
    data: { url, format }
  })
}

/**
 * 图片抓取，格式jpg
 *
 * @export
 * @param {any} data
 * @returns
 */
export function fetchImage(url) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/common/image/fetch',
    method: 'post',
    data: { url }
  })
}
